const SEARCH_TABLE_CONFIG = [
  {
    name: 'docDb',
    label: 'База',
    dataFields: ['dbId'],
    type: 'image',
    sortable: false,
    active: true,
    colWidth: 5,
    style:{},
    options: {}
  },
  {
    name: 'docStatus',
    label: 'Статус',
    dataFields: ['statusId', 'statusHint'],
    type: 'icon',
    sortable: false,
    active: true,
    colWidth: 5,
    style:{},
    options: {}
  },
  {
    name: 'docIndex',
    label: 'Индекс',
    dataFields: ['type'],
    type: 'common',
    sortable: true,
    active: true,
    colWidth: 10,
    style:{},
    options: {}
  },
  {
    name: 'docNum',
    label: 'Номер',
    dataFields: ['number'],
    type: 'common',
    sortable: true,
    active: true,
    colWidth: 10,
    style:{},
    options: {}
  },
  {
    name: 'docDate',
    label: 'Дата утверждения',
    dataFields: ['approvalDate'],
    type: 'date',
    sortable: true,
    active: true,
    colWidth: 10,
    style:{},
    options: {}
  },
  {
    name: 'startDate',
    label: 'Дата вступления в силу',
    dataFields: ['startDate'],
    type: 'date',
    sortable: true,
    active: true,
    colWidth: 10,
    style:{},
    options: {}
  },
  {
    name: 'docTitle',
    label: 'Наименование',
    dataFields: ['title'],
    type: 'link',
    sortable: true,
    active: true,
    colWidth: 25,
    style:{},
    options: {}
  },
  {
    name: 'docOrg',
    label: 'Утвержден',
    dataFields: ['organization'],
    type: 'common',
    sortable: false,
    active: true,
    colWidth: 15,
    style:{},
    options: {}
  },
  {
    name: 'userState',
    label: 'Добавить',
    dataFields: ['isFavorite', 'isWatched'],
    type: 'template',
    sortable: false,
    active: true,
    colWidth: 10,
    style:{
      'text-align': 'center'
    },
    options: {}
  }
]

// --------------------------------------------------------
// Пример ячейки с переменным источником данных
// {
//   name: 'docDate',
//   label: ['Дата утверждения', 'Дата вступления в силу'],
//   dataFields: ['approvalDate', 'statusDate'],
//   type: 'date',
//   sortable: true,
//   changeable: true,
//   style:{
//     width: '16%',
//     'text-align': 'center'
//   },
//   options: {
//     currData: 0
//   }
// },

// --------------------------------------------------------
// Пример ячейки с вычисляемыми данными
// {
//   name: 'docOrg',
//   label: 'Утвержден',
//   dataFields: ['organization', 'approvalDate'],
//   type: 'complex',
//   sortable: false,
//   changeable: false,
//   style:{
//     width: '15%'
//   },
//   options: {
//     action: 'docOrgFunction'
//   }
// },

export default SEARCH_TABLE_CONFIG